/**
 * Utilitaires pour la détection d'environnement et la configuration
 */

/**
 * Détermine si l'application s'exécute en mode développement
 * @returns {boolean} true si en développement, false sinon
 */
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development' || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1';
};

/**
 * Détermine si l'application s'exécute en mode production
 * @returns {boolean} true si en production, false sinon
 */
export const isProduction = () => {
  return process.env.NODE_ENV === 'production';
};

/**
 * Log conditionnel - affiche uniquement en développement
 * @param {...any} args - Arguments à logger
 */
export const devLog = (...args) => {
  if (isDevelopment()) {
    console.log(...args);
  }
};

/**
 * Log d'erreur conditionnel - affiche uniquement en développement pour les logs de debug
 * Les erreurs critiques sont toujours affichées
 * @param {string} message - Message d'erreur
 * @param {any} error - Erreur à logger
 * @param {boolean} critical - Si true, affiche même en production
 */
export const devError = (message, error, critical = false) => {
  if (critical || isDevelopment()) {
    console.error(message, error);
  }
};

/**
 * Obtient la configuration de l'environnement actuel
 * @returns {Object} Configuration d'environnement
 */
export const getEnvironmentConfig = () => {
  return {
    isDev: isDevelopment(),
    isProd: isProduction(),
    hostname: window.location.hostname,
    nodeEnv: process.env.NODE_ENV
  };
};
